// extracted by mini-css-extract-plugin
export default {"container":"Yp-z","ratingLayout":"Zp-z","ratingLabel":"_p-z","nonInteractiveRatingLabel":"aq-z"};